import { Card } from '@/shared/components/ui/card'

/** Esqueleto de la tarjeta de balance. */
export function BalanceCardSkeleton() {
  return (
    <Card>
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="h-11 w-11 animate-pulse rounded-xl bg-surface" />
          <div className="space-y-2">
            <div className="h-3 w-28 animate-pulse rounded bg-surface" />
            <div className="h-8 w-36 animate-pulse rounded bg-surface" />
          </div>
        </div>
        <div className="h-10 w-40 animate-pulse rounded-lg bg-surface" />
      </div>
    </Card>
  )
}

/** Esqueleto de filas de tabla (historial). */
export function MovementsTableSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div className="divide-y divide-line">
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="flex items-center gap-4 py-3">
          <div className="h-4 w-36 animate-pulse rounded bg-surface" />
          <div className="h-6 w-24 animate-pulse rounded-full bg-surface" />
          <div className="ml-auto h-4 w-20 animate-pulse rounded bg-surface" />
        </div>
      ))}
    </div>
  )
}
